import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"

// Photo upload + preview + remove controller for the admin edit_full submission form.
// Uses Active Storage DirectUpload to upload each selected file, then appends a hidden
// input with the resulting blob's signed_id so the form submit carries it. Existing
// photo rows are rendered server-side; this controller manages their removal too.
//
// Server-side: SubmissionsController#update reads the signed_ids array, calls
// process_photo_uploads which reconciles InspectionPhoto records.
export default class extends Controller {
  static targets = ["previews", "item", "status"]
  static values = {
    fieldKey: String,
    directUploadUrl: String,
    inputName: String
  }

  filesSelected(event) {
    const files = Array.from(event.target.files || [])
    if (files.length === 0) return

    files.forEach((file) => this.uploadFile(file))

    // Reset so selecting the same file again still triggers change
    event.target.value = ""
  }

  uploadFile(file) {
    this.setStatus(`Uploading ${file.name}…`)

    const upload = new DirectUpload(file, this.directUploadUrlValue)
    upload.create((error, blob) => {
      if (error) {
        this.setStatus(`Upload failed: ${error}`, true)
        return
      }
      this.appendPhoto(blob.signed_id, URL.createObjectURL(file))
      this.setStatus("")
    })
  }

  appendPhoto(signedId, localUrl) {
    const wrapper = document.createElement("div")
    wrapper.className = "relative group"
    wrapper.dataset.editFullPhotoTarget = "item"
    wrapper.dataset.signedId = signedId
    wrapper.innerHTML = `
      <input type="hidden" name="${this.inputNameValue}" value="${signedId}">
      <img src="${localUrl}" class="h-20 w-20 object-cover rounded border border-gray-200">
      <button type="button"
              data-action="click->edit-full-photo#removePhoto"
              class="absolute -top-2 -right-2 h-6 w-6 rounded-full bg-red-500 text-white flex items-center justify-center text-xs shadow opacity-0 group-hover:opacity-100 transition">
        ×
      </button>
    `
    this.previewsTarget.appendChild(wrapper)
  }

  removePhoto(event) {
    const item = event.currentTarget.closest("[data-edit-full-photo-target='item']")
    if (item) item.remove()
  }

  setStatus(text, isError = false) {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = text
    this.statusTarget.className = isError
      ? "text-xs text-red-600"
      : "text-xs text-gray-500"
  }
}
